import axiosInstance from "@/lib/axiosInstance";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
import { s3Endpoints } from "./s3.endpoints";

export interface GetS3DownloadUrlPayload {
  key: string;
}

export interface GetS3DownloadUrlResponse {
  success: boolean;
  data: {
    url: string;
    key: string;
    expiresIn: number;
  };
}

export const getS3DownloadUrl = async (
  payload: GetS3DownloadUrlPayload,
  actingEntityId?: string,
): Promise<GetS3DownloadUrlResponse> => {
  const response = await axiosInstance.post<GetS3DownloadUrlResponse>(
    s3Endpoints.getDownloadUrl,
    payload,
    { actingEntityId } as CustomAxiosRequestConfig,
  );
  return response.data;
};

/*
 * The upload half of the same endpoint the download URL uses. The caller chooses the key, so
 * whoever calls this owns the prefix and therefore where the object lands.
 */
export interface GetS3UploadUrlPayload {
  key: string;
  contentType: string;
}

export interface GetS3UploadUrlResponse {
  success: boolean;
  data: {
    url: string;
    key: string;
    expiresIn: number;
  };
}

export const getS3UploadUrl = async (
  payload: GetS3UploadUrlPayload,
): Promise<GetS3UploadUrlResponse> => {
  const response = await axiosInstance.post<GetS3UploadUrlResponse>(
    s3Endpoints.getUploadUrl,
    payload,
  );
  return response.data;
};
